// extracted by mini-css-extract-plugin
module.exports = {"container":"Workers_container__2l3TF","header":"Workers_header__hJNZZ","slider":"Workers_slider__5IDHY","addButton":"Workers_addButton__7LhbX","tabs":"Workers_tabs__1xGto"};